import { FC } from "react";

import { AccordionItem } from "components/accordion-item/AccordionItem";
import { CustomSection } from "components/custom-section";
import { normalizeAssetUrl } from "helpers/url";
import { IFlattenedCustomSection } from "interfaces/customer-details";
import { IButtonData } from "services/custom-section";
import { IWidget } from "store/entities/applications";

import { SectionWrapper } from "./styles";

interface IProps {
  widget: IWidget;
  opened: boolean;
  onHeaderClick(): void;
  onCustomSectionButtonClick?: (buttonData: IButtonData, section: IFlattenedCustomSection) => void;
}

export const TicketDetailsWidgetOpening: FC<IProps> = props => {
  // @ts-expect-error TS(18048)
  const { ticketDetailsSections = [] } = props.widget.shortcut.initialState
    ? // @ts-expect-error TS(18048)
      JSON.parse(props.widget.shortcut.initialState)
    : {};

  if (ticketDetailsSections.length === 0) return null;

  return (
    <SectionWrapper borderTop>
      <AccordionItem
        // @ts-expect-error TS(2322)
        title={props.widget.name}
        icon={
          <img src={normalizeAssetUrl(props.widget.icon)} width="20" height="20" alt={`${props.widget.name} icon`} />
        }
        opened={props.opened}
        onHeaderClick={props.onHeaderClick}
      >
        {/* TODO: Fix this the next time the file is edited. */}
        {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
        {ticketDetailsSections.map((section: any) => (
          <CustomSection
            key={props.widget.appId}
            section={section}
            // FIXME: Fix this the next time the file is edited.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            onButtonClick={(buttonData: any) =>
              // @ts-expect-error TS(2722)
              props.onCustomSectionButtonClick(buttonData, {
                ...section,
                pluginId: props.widget.id,
              })
            }
          />
        ))}
      </AccordionItem>
    </SectionWrapper>
  );
};
